"use strict";

var _defineProperty = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _colors = require("../config/colors.config");
var _OtpDetails = _interopRequireDefault(require("./OtpDetails"));
var _OtpVerifySmsCode = _interopRequireDefault(require("./OtpVerifySmsCode"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var OtpPopup = function OtpPopup(_ref) {
  var handleVerify = _ref.handleVerify,
    onClose = _ref.onClose,
    handlePostOtpDetails = _ref.handlePostOtpDetails,
    handleResend = _ref.handleResend,
    classes = _ref.classes,
    open = _ref.open,
    commonErrorMessage = _ref.commonErrorMessage,
    clearError = _ref.clearError,
    tokenReceived = _ref.tokenReceived,
    handleBack = _ref.handleBack,
    tokenLoading = _ref.tokenLoading,
    verifyLoading = _ref.verifyLoading,
    showNID = _ref.showNID,
    otpMethods = _ref.otpMethods,
    showWhatsappButton = _ref.showWhatsappButton;
  var _react$default$useSta = _react.default.useState({
      fullname: '',
      phoneNumber: '',
      tou: false
    }),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    otpData = _react$default$useSta2[0],
    setOtpData = _react$default$useSta2[1];
  (0, _react.useEffect)(function () {
    if (!open) {
      clearError();
    }
  }, [open, clearError]);
  return /*#__PURE__*/_react.default.createElement(_core.Modal, {
    open: open,
    onClose: onClose,
    className: classes.modal,
    BackdropComponent: _core.Backdrop
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: classes.paper
  }, !tokenReceived ? /*#__PURE__*/_react.default.createElement(StyledOtpDetails, {
    data: otpData,
    showNID: showNID,
    commonErrorMessage: commonErrorMessage,
    onChangeData: setOtpData,
    postOtpDetails: handlePostOtpDetails,
    isLoading: tokenLoading,
    otpMethods: otpMethods || ['SMS'],
    showWhatsappButton: showWhatsappButton
  }) : /*#__PURE__*/_react.default.createElement(StyledVerifySmsCode, {
    data: otpData,
    commonErrorMessage: commonErrorMessage,
    clearError: clearError,
    handleVerify: handleVerify,
    handleBack: handleBack,
    handleResend: handleResend,
    isLoading: verifyLoading,
    otpMethods: otpMethods || ['SMS']
  })));
};
var styles = function styles(theme) {
  var _paper;
  return {
    buttonIcon: {
      color: theme.palette.primary.main,
      height: 20,
      marginRight: '8px',
      width: 20
    },
    buttonIconInvert: {
      height: 20,
      marginRight: '8px',
      width: 20
    },
    checkboxLabel: {
      '& a': {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 'normal',
        lineHeight: 1.2
      },
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'normal',
      lineHeight: 1.2,
      paddingTop: 8,
      textAlign: 'left'
    },
    formControl: {
      '& .MuiOutlinedInput-input': {
        fontWeight: 'bold'
      },
      width: '100%'
    },
    justifyImage: {
      position: 'relative',
      right: 30
    },
    linkAlt: {
      '&:hover': {
        backgroundColor: 'transparent'
      },
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(16)
    },
    messageAccent: {
      color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
      fontWeight: 'bold'
    },
    messageDefault: {
      color: theme.palette.secondary.dark
    },
    messageError: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 'bold'
    },
    messageMutted: {
      '&.resize': _defineProperty({}, theme.breakpoints.down('sm'), {
        fontSize: theme.typography.pxToRem(14)
      }),
      color: _colors.Black[170],
      fontSize: theme.typography.pxToRem(18)
    },
    messageSelectOtpMethod: _defineProperty({
      color: theme.palette.secondary.dark,
      direction: 'ltr',
      fontSize: '2.2142rem',
      textAlign: 'center'
    }, theme.breakpoints.down('sm'), {
      fontSize: theme.typography.pxToRem(28)
    }),
    messageTop: _defineProperty({
      color: theme.palette.secondary.dark,
      direction: 'ltr',
      fontSize: '2.2142rem',
      textAlign: 'center'
    }, theme.breakpoints.down('sm'), {
      fontSize: theme.typography.pxToRem(15)
    }),
    modal: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      overflow: 'scroll'
    },
    noFill: {
      '&.MuiButton-root.MuiButton-containedPrimary': {
        color: theme.palette.primary.main
      },
      '&.MuiButton-root.Mui-disabled': {
        backgroundColor: 'transparent',
        color: 'rgba(0, 0, 0, 0.26)'
      },
      '&:hover': {
        backgroundColor: 'unset',
        boxShadow: 'unset',
        opacity: 0.8
      },
      backgroundColor: 'transparent',
      boxShadow: 'unset',
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      lineHeight: 1,
      padding: '8px 12px',
      width: '100%'
    },
    paper: (_paper = {
      '&:focus': {
        outline: 'none'
      },
      borderRadius: 20,
      margin: 20
    }, _defineProperty(_paper, theme.breakpoints.down('sm'), {
      margin: '78px 12px 12px',
      padding: theme.spacing(3, 3, 3, 3)
    }), _defineProperty(_paper, "maxWidth", 1012), _defineProperty(_paper, "padding", theme.spacing(10, 12, 8, 15)), _paper),
    submitButton: {
      color: _colors.Black[20],
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 'bold',
      width: '100%'
    },
    submitButtonInvert: {
      backgroundColor: 'transparent',
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 'bold',
      width: '100%'
    },
    textButton: _defineProperty({
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 'bold'
    }, theme.breakpoints.down('xs'), {
      width: '100%'
    }),
    textVeryLarge: _defineProperty({
      color: _helpers.agentDeveloperUtils.getPrimaryColor(450),
      fontSize: 100,
      fontWeight: 300,
      letterSpacing: 0,
      lineHeight: '100px'
    }, theme.breakpoints.down('sm'), {
      fontSize: 86,
      lineHeight: '86px'
    }),
    touError: {
      margin: '0 14px'
    },
    withBorder: _defineProperty({
      borderColor: _helpers.agentDeveloperUtils.getSecondaryColor(100)
    }, theme.breakpoints.down('sm'), {
      border: 'none'
    })
  };
};
var StyledVerifySmsCode = (0, _styles.withStyles)(styles)(_OtpVerifySmsCode.default);
var StyledOtpDetails = (0, _styles.withStyles)(styles)(_OtpDetails.default);
OtpPopup.propTypes = {
  classes: _propTypes.default.object,
  clearError: _propTypes.default.func,
  commonErrorMessage: _propTypes.default.string,
  handleBack: _propTypes.default.func,
  handlePostOtpDetails: _propTypes.default.func,
  handleResend: _propTypes.default.func,
  handleVerify: _propTypes.default.func,
  onClose: _propTypes.default.func,
  open: _propTypes.default.bool,
  otpMethods: _propTypes.default.array,
  showNID: _propTypes.default.bool,
  showWhatsappButton: _propTypes.default.bool,
  tokenLoading: _propTypes.default.bool,
  tokenReceived: _propTypes.default.bool,
  verifyLoading: _propTypes.default.bool
};
var _default = exports.default = (0, _styles.withStyles)(styles)(OtpPopup);